import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../constants/constants';
export const componentKey = "HOME_SECTION";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setStatusList: (state, action) => {
            state.statusList = action.payload;
        },
        setFormList: (state, action) => {
            state.formList = action.payload;
        },
        setYearList: (state, action) => {
            state.yearList = action.payload;
        },
        setReportData: (state, action) => {
            state.reportData = action.payload;
        },
        setSelectedYear: (state, action) => {
            state.selectedYear = action.payload;
        },
        setSelectedForm: (state, action) => {
            state.selectedForm = action.payload;
        },
        setSelectedStatus: (state, action) => {
            state.selectedStatus = action.payload;
        },
        setRowsPerPage: (state, action) => {
            state.rowsPerPage = action.payload;
        },
        setSkip: (state, action) => {
            state.skip = action.payload;
        },
        setTin: (state, action) => {
            state.tin = action.payload;
        },
        setTypeReference: (state, action) => {
            state.typeReference = action.payload;
        },
        setTotalReport: (state, action) => {
            state.totalReport = action.payload;
        },
        setExportFile: (state, action) => {
            state.exportFile = action.payload;
        },
        setIsNewUser: (state, action) => {
            state.isNewUser = action.payload;
        },
        setIsNewUserLoading: (state, action) => {
            state.isNewUserLoading = action.payload;
        },
        setInsights: (state, action) => {
            state.insights = action.payload;
        },
        setUrgentIssues: (state, action) => {
            state.urgentIssues = action.payload;
        },
        setShowTestAccountWarningModal: (state, action) => {
            state.showTestAccountWarningModal = action.payload;
        },
    },
    initialReducerState: {
        loadingState: { state: PAGE_STATE.PRE_LOADING, message: "" },
        statusList: [],
        formList: [],
        yearList: [],
        reportData: [],
        selectedYear: null,
        selectedForm: null,
        selectedStatus: null,
        rowsPerPage: 10,
        skip: 0,
        tin: '',
        typeReference: '',
        totalReport: 0,
        exportFile: {},
        isNewUser: false,
        isNewUserLoading: true,
        insights: {},
        urgentIssues: {},
        showTestAccountWarningModal: false,
    }
});
export const { 
    setIsNewUser, 
    setIsNewUserLoading, 
    setLoadingState, 
    setExportFile, 
    setTotalReport, 
    setTin, 
    setTypeReference, 
    setRowsPerPage, 
    setSkip, 
    setSelectedYear, 
    setSelectedForm, 
    setSelectedStatus, 
    setReportData, 
    setStatusList, 
    setFormList, 
    setYearList,
    setInsights,
    setUrgentIssues,
    setShowTestAccountWarningModal,
 } = actions;
